'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = decamelize;
// Fork of https://github.com/sindresorhus/decamelize because it contains ES6 code
// and css properties don't contain unicode
var separator = '-';
var regex1 = /([a-z\d])([A-Z])/g;
var regex2 = /([a-z]+)([A-Z][a-z\d]+)/g;

function decamelize(text) {
  return text.replace(regex1, '$1' + separator + '$2').replace(regex2, '$1' + separator + '$2').toLowerCase();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9kZWNhbWVsaXplLmpzIl0sIm5hbWVzIjpbImRlY2FtZWxpemUiLCJzZXBhcmF0b3IiLCJyZWdleDEiLCJyZWdleDIiLCJ0ZXh0IiwicmVwbGFjZSIsInRvTG93ZXJDYXNlIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFNd0JBLFU7QUFOeEI7QUFDQTtBQUNBLElBQU1DLFlBQVksR0FBbEI7QUFDQSxJQUFNQyxTQUFTLG1CQUFmO0FBQ0EsSUFBTUMsU0FBUywwQkFBZjs7QUFFZSxTQUFTSCxVQUFULENBQW9CSSxJQUFwQixFQUEwQjtBQUN2QyxTQUFPQSxLQUNKQyxPQURJLENBQ0lILE1BREosU0FDaUJELFNBRGpCLFNBRUpJLE9BRkksQ0FFSUYsTUFGSixTQUVpQkYsU0FGakIsU0FHSkssV0FISSxFQUFQO0FBSUQiLCJmaWxlIjoiZGVjYW1lbGl6ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEZvcmsgb2YgaHR0cHM6Ly9naXRodWIuY29tL3NpbmRyZXNvcmh1cy9kZWNhbWVsaXplIGJlY2F1c2UgaXQgY29udGFpbnMgRVM2IGNvZGVcbi8vIGFuZCBjc3MgcHJvcGVydGllcyBkb24ndCBjb250YWluIHVuaWNvZGVcbmNvbnN0IHNlcGFyYXRvciA9ICctJ1xuY29uc3QgcmVnZXgxID0gLyhbYS16XFxkXSkoW0EtWl0pL2dcbmNvbnN0IHJlZ2V4MiA9IC8oW2Etel0rKShbQS1aXVthLXpcXGRdKykvZ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkZWNhbWVsaXplKHRleHQpIHtcbiAgcmV0dXJuIHRleHRcbiAgICAucmVwbGFjZShyZWdleDEsIGAkMSR7c2VwYXJhdG9yfSQyYClcbiAgICAucmVwbGFjZShyZWdleDIsIGAkMSR7c2VwYXJhdG9yfSQyYClcbiAgICAudG9Mb3dlckNhc2UoKVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/utils/decamelize.js
// module id = 351
// module chunks = 0